// extracted by mini-css-extract-plugin
module.exports = {"simpleClear":"TextInput_simpleClear__J7zYs","visible":"TextInput_visible__2Ir-d","error":"TextInput_error__3LxNv"};